import React from 'react';

import { FieldProps } from '@api';
import { Form } from '@ui-library/form';
import { Switch } from '@ui-library/switch';

export const SwitchField: React.FC<FieldProps<'switchField'>> = ({ fieldConfig }) => (
  <Form.Item
    name={fieldConfig.key}
    label={fieldConfig.label}
    extra={fieldConfig.info}
    valuePropName="checked"
    rules={[{ required: !fieldConfig.optional }, ...(fieldConfig.rules ?? [])]}
    initialValue={fieldConfig.default}
  >
    <Switch disabled={fieldConfig.disabled} />
  </Form.Item>
);
